// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsors-page .sponsor-row {
  height: 60px; }
  .sponsors-page .sponsor-row img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-height: 50px;
    max-width: 90%;
    position: relative;
    top: 40%;
    transform: translateY(-50%); }
  .sponsors-page .sponsor-row a:hover {
    text-decoration: none;
    color: #4330ff;
    opacity: 0.7; }

.sponsor-page {
  padding: 1em 0 1em 0; }
  .sponsor-page hr {
    margin-top: 0;
    margin-bottom: 0; }
  .sponsor-page .logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    max-width: 225px;
    height: auto; }
  .sponsor-page .no-logo {
    text-align: center;
    margin-bottom: 20px;
    font-size: x-large; }
  .sponsor-page button {
    width: 100%;
    border-radius: 5px;
    background-color: #f2f2f2;
    border: 1px solid #c0c0c0;
    color: #4330ff;
    margin-bottom: 0.5em; }
  .sponsor-page .active-button {
    background-color: #4330ff;
    color: white; }
  .sponsor-page .blue-header {
    color: #4330ff; }
  .sponsor-page .user-list {
    padding: 5px 0 5px 0;
    position: relative; }
    .sponsor-page .user-list .user-icons {
      margin: .5em;
      color: #606060;
      position: absolute;
      top: 0;
      right: 0; }
      .sponsor-page .user-list .user-icons ul li {
        list-style-type: none; }
  .sponsor-page .external-link a {
    color: #4330ff;
    cursor: default; }
    .sponsor-page .external-link a:hover {
      text-decoration: none; }
  .sponsor-page .media-section a {
    color: #000;
    display: block;
    width: 100%;
    float: left; }
    .sponsor-page .media-section a:hover {
      text-decoration: none; }
    .sponsor-page .media-section a ul {
      float: left; }
      .sponsor-page .media-section a ul li {
        border-bottom: none;
        margin: -10px 15px;
        color: #c0c0c0; }
        .sponsor-page .media-section a ul li.attachment-title {
          font-size: 1.1em;
          font-weight: bold;
          color: #000; }
        .sponsor-page .media-section a ul li:hover {
          background: transparent; }
  .sponsor-page .media-section .fa {
    font-size: 2.5em; }
  .sponsor-page .media-section .chevron {
    color: #c0c0c0;
    font-size: .75em; }
  .sponsor-page .media-section ul {
    padding-left: 0px; }
    .sponsor-page .media-section ul li {
      list-style: none;
      border-bottom: 2px solid #eaeaea;
      padding: .5em 0;
      display: block;
      width: 100%;
      float: left; }
      .sponsor-page .media-section ul li:hover {
        background-color: #f2f2f2; }
  .sponsor-page .has-note {
    background-color: #4330ff;
    color: white; }

.no-logo {
  text-align: center;
  color: #404040;
  font-size: 30px; }

.media-section a {
  color: #000;
  display: block;
  width: 100%;
  float: left; }
  .media-section a:hover {
    text-decoration: none; }
  .media-section a ul {
    float: left; }
    .media-section a ul li {
      border-bottom: none;
      margin: -10px 15px;
      color: #c0c0c0; }
      .media-section a ul li.attachment-title {
        font-size: 1.1em;
        font-weight: bold;
        color: #000; }
      .media-section a ul li:hover {
        background: transparent; }

.media-section .fa {
  font-size: 2.5em; }

.media-section .chevron {
  color: #c0c0c0;
  font-size: .75em; }

.media-section ul {
  padding-left: 0px; }
  .media-section ul li {
    list-style: none;
    border-bottom: 2px solid #eaeaea;
    padding: .5em 0;
    display: block;
    width: 100%;
    float: left; }
    .media-section ul li:hover {
      background-color: #f2f2f2; }

.note-page .sponsor-logo {
  text-align: center; }
  .note-page .sponsor-logo img {
    height: auto;
    max-width: 225px; }
  .note-page .sponsor-logo:hover {
    cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/components/Sponsors/sponsors.css"],"names":[],"mappings":"AAAA;EACE,YAAY,EAAE;EACd;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,2BAA2B,EAAE;EAC/B;IACE,qBAAqB;IACrB,cAAc;IACd,YAAY,EAAE;;AAElB;EACE,oBAAoB,EAAE;EACtB;IACE,aAAa;IACb,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY,EAAE;EAChB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB,EAAE;EACtB;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oBAAoB,EAAE;EACxB;IACE,yBAAyB;IACzB,YAAY,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,oBAAoB;IACpB,kBAAkB,EAAE;IACpB;MACE,YAAY;MACZ,cAAc;MACd,kBAAkB;MAClB,MAAM;MACN,QAAQ,EAAE;MACV;QACE,qBAAqB,EAAE;EAC7B;IACE,cAAc;IACd,eAAe,EAAE;IACjB;MACE,qBAAqB,EAAE;EAC3B;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW,EAAE;IACb;MACE,qBAAqB,EAAE;IACzB;MACE,WAAW,EAAE;MACb;QACE,mBAAmB;QACnB,kBAAkB;QAClB,cAAc,EAAE;QAChB;UACE,gBAAgB;UAChB,iBAAiB;UACjB,WAAW,EAAE;QACf;UACE,uBAAuB,EAAE;EACjC;IACE,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;IACnB;MACE,gBAAgB;MAChB,gCAAgC;MAChC,eAAe;MACf,cAAc;MACd,WAAW;MACX,WAAW,EAAE;MACb;QACE,yBAAyB,EAAE;EACjC;IACE,yBAAyB;IACzB,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW,EAAE;EACb;IACE,qBAAqB,EAAE;EACzB;IACE,WAAW,EAAE;IACb;MACE,mBAAmB;MACnB,kBAAkB;MAClB,cAAc,EAAE;MAChB;QACE,gBAAgB;QAChB,iBAAiB;QACjB,WAAW,EAAE;MACf;QACE,uBAAuB,EAAE;;AAEjC;EACE,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;EACnB;IACE,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,WAAW;IACX,WAAW,EAAE;IACb;MACE,yBAAyB,EAAE;;AAEjC;EACE,kBAAkB,EAAE;EACpB;IACE,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,eAAe,EAAE","sourcesContent":[".sponsors-page .sponsor-row {\n  height: 60px; }\n  .sponsors-page .sponsor-row img {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    max-height: 50px;\n    max-width: 90%;\n    position: relative;\n    top: 40%;\n    transform: translateY(-50%); }\n  .sponsors-page .sponsor-row a:hover {\n    text-decoration: none;\n    color: #4330ff;\n    opacity: 0.7; }\n\n.sponsor-page {\n  padding: 1em 0 1em 0; }\n  .sponsor-page hr {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .sponsor-page .logo {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 20px;\n    max-width: 225px;\n    height: auto; }\n  .sponsor-page .no-logo {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: x-large; }\n  .sponsor-page button {\n    width: 100%;\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    color: #4330ff;\n    margin-bottom: 0.5em; }\n  .sponsor-page .active-button {\n    background-color: #4330ff;\n    color: white; }\n  .sponsor-page .blue-header {\n    color: #4330ff; }\n  .sponsor-page .user-list {\n    padding: 5px 0 5px 0;\n    position: relative; }\n    .sponsor-page .user-list .user-icons {\n      margin: .5em;\n      color: #606060;\n      position: absolute;\n      top: 0;\n      right: 0; }\n      .sponsor-page .user-list .user-icons ul li {\n        list-style-type: none; }\n  .sponsor-page .external-link a {\n    color: #4330ff;\n    cursor: default; }\n    .sponsor-page .external-link a:hover {\n      text-decoration: none; }\n  .sponsor-page .media-section a {\n    color: #000;\n    display: block;\n    width: 100%;\n    float: left; }\n    .sponsor-page .media-section a:hover {\n      text-decoration: none; }\n    .sponsor-page .media-section a ul {\n      float: left; }\n      .sponsor-page .media-section a ul li {\n        border-bottom: none;\n        margin: -10px 15px;\n        color: #c0c0c0; }\n        .sponsor-page .media-section a ul li.attachment-title {\n          font-size: 1.1em;\n          font-weight: bold;\n          color: #000; }\n        .sponsor-page .media-section a ul li:hover {\n          background: transparent; }\n  .sponsor-page .media-section .fa {\n    font-size: 2.5em; }\n  .sponsor-page .media-section .chevron {\n    color: #c0c0c0;\n    font-size: .75em; }\n  .sponsor-page .media-section ul {\n    padding-left: 0px; }\n    .sponsor-page .media-section ul li {\n      list-style: none;\n      border-bottom: 2px solid #eaeaea;\n      padding: .5em 0;\n      display: block;\n      width: 100%;\n      float: left; }\n      .sponsor-page .media-section ul li:hover {\n        background-color: #f2f2f2; }\n  .sponsor-page .has-note {\n    background-color: #4330ff;\n    color: white; }\n\n.no-logo {\n  text-align: center;\n  color: #404040;\n  font-size: 30px; }\n\n.media-section a {\n  color: #000;\n  display: block;\n  width: 100%;\n  float: left; }\n  .media-section a:hover {\n    text-decoration: none; }\n  .media-section a ul {\n    float: left; }\n    .media-section a ul li {\n      border-bottom: none;\n      margin: -10px 15px;\n      color: #c0c0c0; }\n      .media-section a ul li.attachment-title {\n        font-size: 1.1em;\n        font-weight: bold;\n        color: #000; }\n      .media-section a ul li:hover {\n        background: transparent; }\n\n.media-section .fa {\n  font-size: 2.5em; }\n\n.media-section .chevron {\n  color: #c0c0c0;\n  font-size: .75em; }\n\n.media-section ul {\n  padding-left: 0px; }\n  .media-section ul li {\n    list-style: none;\n    border-bottom: 2px solid #eaeaea;\n    padding: .5em 0;\n    display: block;\n    width: 100%;\n    float: left; }\n    .media-section ul li:hover {\n      background-color: #f2f2f2; }\n\n.note-page .sponsor-logo {\n  text-align: center; }\n  .note-page .sponsor-logo img {\n    height: auto;\n    max-width: 225px; }\n  .note-page .sponsor-logo:hover {\n    cursor: pointer; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
